import { createAsyncThunk } from "@reduxjs/toolkit";
import { AXIOS_RESERVATION } from "../../../../utils/axiosInterceptors";
import { config } from "../../../../config";

export const getcategory = createAsyncThunk(
  "categories/getcategory",
  async (state, { rejectWithValue }) => {
    try {
      let { data } = await AXIOS_RESERVATION.get("getcategory");
      return data;
    } catch (err) {
      console.error("Error occured in getCategoryComponents API call: ", err);
      return rejectWithValue(err.message);
    }
  }
);

export const getAllDepartments = createAsyncThunk(
  "categories/getAllDepartments",
  async (state, { rejectWithValue }) => {
    try {
      let { data } = await AXIOS_RESERVATION.get("getAllDepartments");
      return data;
    } catch (err) {
      console.error("Error occured in getAllDepartments API call: ", err);
    }
  }
);

export const getAllCategories = createAsyncThunk(
  "categories/getAllCategories",
  async (state, { rejectWithValue }) => {
    try {
      let { data } = await AXIOS_RESERVATION.get("getAllCategories");
      console.log("data:", data);
      return data;
    } catch (err) {
      console.error("Error occured in getAllCategories API call: ", err);
      return rejectWithValue(err.message);
    }
  }
);

export const addNewCategory = createAsyncThunk(
  "adminuser/addcategory",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { CB, ...others } = state;
    others.hotelId = config.HOTELID;

    var headers = {
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.post(`addcategory`, others, {
        headers,
      });

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcategory());

        return data;
      }
    } catch (err) {
      CB && CB(err);
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const editCategory = createAsyncThunk(
  "adminuser/updatecategory",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { CB, ...others } = state;

    try {
      let { data } = await AXIOS_RESERVATION.post(`updatecategory`, others);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcategory());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong Please try again later",
        },
      });
    }
  }
);
export const deleteCategory = createAsyncThunk(
  "adminuser/removecategory",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { id, CB } = state;

    var headers = {
      _id: id,
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.delete(`removecategory`, {
        headers,
      });

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcategory());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);
